import React from "react";
import { stackList } from "../../data/ProjectData";
import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
function About() {
  return (
    <ContactWrapper id="about">
      <div className="Container">
        <div className="SectionTitle">Om meg</div>
        <div className="BigCard">
          <Image
            src="https://i.pinimg.com/originals/d5/b0/4c/d5b04cc3dcd8c17702549ebc5f1acf1a.png"
            alt="man-svgrepo"
          />
          <div className="AboutBio">
            Hei mitt navn er <strong>Sander Pettersen</strong>. <br />
            Jeg er en student som akkurat har blitt ferdig med videregående. Jeg
            har gått 3 år med programmering og modellering på Skien videregående
            skole. Jeg liker for det meste å jobbe med fullstack web utvikling.
          </div>
          <div className="AboutBio tagline2">
            Jeg er komfortabel med disse teknologiene:
          </div>
          <Technologies>
            {stackList.map((stack, index) => (
              <Tech key={index} className="tech">
                <TechImg src={stack.img} alt={stack.name} />
                <TechName>{stack.name}</TechName>
              </Tech>
            ))}
          </Technologies>
        </div>
      </div>
    </ContactWrapper>
  );
}

export default About;
